import { render, staticRenderFns } from "./TabSmsHistory.vue?vue&type=template&id=6200c0e6&"
import script from "./TabSmsHistory.vue?vue&type=script&lang=js&"
export * from "./TabSmsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports